import { cacheGet, cacheSet } from './db';

export async function cachedGet<T>(
  key: string,
  fetcher: () => Promise<T>,
  familyId: string | null = null,
): Promise<T> {
  try {
    const data = await fetcher();
    await cacheSet(key, data, familyId);
    return data;
  } catch (error) {
    const cached = await cacheGet<T>(key);
    if (cached !== null) return cached;
    throw error;
  }
}

export async function updateCachedList<T>(
  key: string,
  updater: (current: T[]) => T[],
  familyId: string | null = null,
): Promise<void> {
  const current = (await cacheGet<T[]>(key)) ?? [];
  await cacheSet(key, updater(current), familyId);
}
